export default __webpack_public_path__ + "media/images/service_accommodation-4fa65d278b695e88d4c35661d7005c81.jpg";